import styled from "styled-components";

export const StyledSection = styled.section`
  background-color: ${props => props.theme.colors.appGrey1};
`;

export const Wrapper = styled.div`
  ${props => props.theme.wrapper}
`;
